import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type AttachmentDocumentTypeOption } from '../domain/Document'
import { ShipperRepository } from '../infra/ShipperRepository'

export type ListAttachmentDocumentTypesFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function listAttachmentDocumentTypesFactory({
  shipperRepository,
}: ListAttachmentDocumentTypesFactoryDependencies) {
  return async function (
    config?: { signal?: AbortSignal }
  ): Promise<AttachmentDocumentTypeOption[]> {
    return shipperRepository.listAttachmentDocumentTypes(config)
  }
}

export function listAttachmentDocumentTypes(
  config?: { signal?: AbortSignal }
): Promise<AttachmentDocumentTypeOption[]> {
  const httpClient = new HttpClient(API_URL)
  const shipperRepository = new ShipperRepository({ httpClient })
  const listFn = listAttachmentDocumentTypesFactory({ shipperRepository })
  return listFn(config)
}
